// Import Dependencies
import React from 'react';
import kebabCase from 'lodash/kebabCase';

import NumberCard from '~/common/components/NumberCard';

import { PATH_CUSTOM_TOLL_FREE, PATH_LOCAL_RECOMMEND, PATH_TRANSFER_CURRENT_NUMBER } from '~/common/utils/consts.js';

// import images
import tollFreeSvgSrc from '~/common/images/toll-free-icon.svg';
import localSvgSrc from '~/common/images/map-pin-icon.svg';
import transferSvgSrc from '~/common/images/number-port-icon.svg';

// Import Local Styles
import styles from './trial-numbers.css';

const cardConfigs = [
    {
        type: 'Toll Free',
        to: PATH_CUSTOM_TOLL_FREE,
        titleText: 'Toll Free or Vanity',
        badgeAlt: 'toll free badge',
        badgeSrc: tollFreeSvgSrc,
        summaryText: 'Look bigger, national, and more established; customize a number, or let us generate one.',
        dataTest: 'toll-free-number-button'
    },
    {
        type: 'Local',
        to: PATH_LOCAL_RECOMMEND,
        titleText: 'Local',
        badgeAlt: 'local badge',
        badgeSrc: localSvgSrc,
        summaryText: 'Connect with your community by choosing a number with a local area code.',
        dataTest: 'local-number-button'
    },
    {
        type: 'Transfer',
        to: PATH_TRANSFER_CURRENT_NUMBER,
        titleText: 'Number Porting',
        badgeAlt: 'transfer badge',
        badgeSrc: transferSvgSrc,
        summaryText: 'Already have a separate business number? Keep it by porting it over to Grasshopper!',
        dataTest: 'transfer-number-button'
    }
];

const TrialNumbers = () => {
    return (
        <div className={styles.wrapper}>
            <h1 className={styles.title}>Which number is right for you?</h1>
            {cardConfigs.map(config => (
                <NumberCard
                    id={`page-section_${kebabCase(config.type)}`}
                    key={config.type}
                    {...config}
                />
            ))}
        </div>
    );
};

export default TrialNumbers;
